export const getSVGSize = (url: string) => {
  return new Promise((resolve, reject) => {
    fetch(url)
      .then(r => r.text())
      .then(t => {
        if (!t) {
          throw 'no text in response.';
        }

        let svg: HTMLElement | SVGSVGElement | null = document.createElement(
          'div'
        );
        svg.innerHTML = t;
        svg = svg.querySelector('svg');

        if (!svg) {
          throw 'no svg in response. something went really wrong here.';
        }

        let viewBox: any = svg.getAttribute('viewBox');

        let w;
        let h;

        if (viewBox) {
          viewBox = viewBox.split(/ /g);
          w = viewBox[2];
          h = viewBox[3];
        }

        const width = svg.getAttribute('width');
        const height = svg.getAttribute('height');

        if (width && height) {
          w = width;
          h = height;
        }

        if (!w || !h) {
          throw 'no width or height values are set in svg.';
        }

        // do not want to use defaults. if the values are not there we want to know
        // { width: w || 1100, height: h || 618.75 }
        resolve({ width: w, height: h } as any);
      })
      .catch(err => {
        reject(err);
      });
  });
};
